"use client";

import * as React from "react";

const FenestraBaseUrlContext = React.createContext<string | null>(null);

export function FenestraUrlProvider({
  baseUrl,
  children,
}: {
  baseUrl: string | null;
  children: React.ReactNode;
}) {
  return (
    <FenestraBaseUrlContext.Provider value={baseUrl}>{children}</FenestraBaseUrlContext.Provider>
  );
}

export function useFenestraBaseUrl(): string | null {
  return React.useContext(FenestraBaseUrlContext);
}
